import { AUTH_API_ENDPOINTS, USER_MANAGEMENT_API_ENDPOINTS } from '@/constants';
import {
  IAuthProfile,
  IExpiredPasswordUpdatePayload,
  IForgotPasswordPayload,
  ILoginWithCredentialsPayload,
  IOTPVerificationPayload,
  ISetupPasswordPayload,
} from '@/interfaces';
import { api } from '@/services';
import { ApiResponse } from '@/types';

const AuthService = {
  loginWithCredentials: async (payload: ILoginWithCredentialsPayload): Promise<void> => {
    await api.post(AUTH_API_ENDPOINTS.AUTH_LOGIN, payload, { skipErrorAlert: true });
  },

  forgotPassword: async (payload: IForgotPasswordPayload): Promise<void> => {
    await api.post(AUTH_API_ENDPOINTS.AUTH_FORGOT_PASSWORD, payload, { skipErrorAlert: true });
  },

  passwordResetVerify: async (payload: ISetupPasswordPayload) => {
    const response = await api.post<ApiResponse<boolean>>(
      AUTH_API_ENDPOINTS.AUTH_PASSWORD_RESETS_VERIFY,
      payload,
      {
        skipErrorAlert: true,
      },
    );
    return response;
  },

  expiredPasswordUpdate: async (payload: IExpiredPasswordUpdatePayload) => {
    const response = await api.post<ApiResponse<boolean>>(
      AUTH_API_ENDPOINTS.AUTH_CHANGE_PASSWORD,
      payload,
      {
        skipErrorAlert: true,
      },
    );
    return response.data;
  },

  logout: async (): Promise<void> => {
    await api.get(AUTH_API_ENDPOINTS.AUTH_LOGOUT);
  },

  getCurrentProfile: async (): Promise<IAuthProfile> => {
    const response = await api.get<ApiResponse<IAuthProfile>>(AUTH_API_ENDPOINTS.AUTH_PROFILE);
    return response.data.data;
  },

  initiatePassword: async (payload: ISetupPasswordPayload): Promise<void> => {
    await api.post(USER_MANAGEMENT_API_ENDPOINTS.INITIATE_PASSWORD, payload);
  },

  ResendOTP: async (email: string): Promise<void> => {
    await api.post(AUTH_API_ENDPOINTS.AUTH_RESEND_OTP.replace(':email', email), null, {
      skipErrorAlert: true,
    });
  },

  VerifyOTP: async (payload: IOTPVerificationPayload) => {
    const response = await api.post<ApiResponse<boolean>>(
      AUTH_API_ENDPOINTS.AUTH_VERIFY_OTP,
      payload,
      {
        skipErrorAlert: true,
      },
    );
    return response.data;
  },
};

export default AuthService;
